import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Button from '@material-ui/core/Button';
import styles from './Styles'

const Event = (props) => {
  const { classes, theme} = props;
  return (
    <div>
    { props.events ? (
    <Card className={classes.card}>
      <CardMedia
        className={classes.cover}
        image={props.events.fields.imageEvents.fields.file.url}
        title={props.events.fields.title}
      />
      <div className={classes.details}>
        <CardContent className={classes.content}>
          <Typography component="p" variant="p">
          {props.events.fields.title}
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            {props.events.fields.publishedAt}
          </Typography>
        </CardContent>
        <div className={classes.controls}>
          <Link to={{ pathname: '/eventdetails/'+props.events.fields.slug}} style={{textDecoration:'none'}}>
            <Button variant="contained" color="primary" className={classes.button}>
                Details
            </Button>
          </Link>        
        </div>
      </div>
    </Card>
    ) : null}
    </div>
  );
}

Event.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Event);





// WEBPACK FOOTER //
// ./src/components/Events/Event.js